import React from "react";
import styled from "styled-components";
import TableFields from "../../../constants/CallDepartments/TableFields.json";
import Table from "../../Common/Table";
import { connect } from "react-redux";
import { FlexContainer, Pill } from "../../../constants/assets/containers";
import { useHistory } from "react-router-dom";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../../constants/Menu/MenuNames";
import Permission from "../../Common/Permission";

const CallDepartmentList = (props) => {
  const history = useHistory();
  const allActions =
    MenuActionsMappings[MenuNames.LOGISTICS_SUPPORT_DEPARTMENTS];

  const { callDepartmentsList } = props;

  const getFieldValue = (obj, key, index) => {
    switch (key) {
      case "breachedOrder":
      case "premiumCustomer":
      case "premiumDp":
      case "enabled":
        return (
          <div className="flex items-center justify-center">
            <Pill isFalse={!obj[key]}>{obj[key] ? "Yes" : "No"}</Pill>
          </div>
        );
      case "action":
        return (
          <Permission
            optionalPerms={[allActions.READ, allActions.UPDATE]}
            notAllowedText="No Actions Permitted"
          >
            <FlexContainer
              justify="flex-start"
              onClick={() => {
                history.push(`/call-departments/${obj.id}`);
              }}
              className={"edit-options cursor-pointer actions-holder"}
              id={`actions_${index}`}
            >
              <span>View/Edit</span>
            </FlexContainer>
          </Permission>
        );
      default:
        return obj[key] ? obj[key] : "-";
    }
  };
  return (
    <CallDepartmentListContainer>
      <Table
        list={callDepartmentsList}
        getFieldValue={getFieldValue}
        fields={TableFields}
      />
    </CallDepartmentListContainer>
  );
};
const CallDepartmentListContainer = styled.section`
  height: calc(100vh - 215px);
`;

function mapStateToProps(state) {
  const { CallDepartments } = state;
  return {};
}
function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(CallDepartmentList);
